import { z } from 'zod';

/**
 * Schema for tool proxy response
 */
export const ToolProxyResponseSchema = z.object({
  // HTTP response details
  status: z.number().describe('HTTP status code'),
  statusText: z.string().describe('HTTP status text'),
  headers: z.record(z.string(), z.string()).describe('Response headers'),
  body: z.string().optional().describe('Response body as string'),

  // Timing information
  timings: z
    .object({
      blocked: z.number().optional(),
      dns: z.number().optional(),
      connect: z.number().optional(),
      send: z.number().optional(),
      wait: z.number(),
      receive: z.number(),
      ssl: z.number().optional(),
    })
    .describe('HAR-compatible timing information'),

  // Metadata
  timestamp: z.string().describe('ISO timestamp of response'),
  harEventId: z.string().optional().describe('ID of the HAR event published'),
});

export type ToolProxyResponseDto = z.infer<typeof ToolProxyResponseSchema>;
